/* global LOYALTY_LEVELS, PREFIX */
import { formatNumber, formatDateForMaistra } from '../../utils-common'

export default {
  name: 'LevelsProgress',
  template: `
<div class="levels-progress">
  <div class="levels-progress__points">
    <div class="levels-progress__box">
      <div>{{ $t('dashboard.youHave') }}</div>
      <div><span class="h2">{{ formatNumber(availablePoints) }}</span> {{ $t('dashboard.points') }}</div>
      <div v-if="expiresOn">{{ $t('dashboard.expiresOn') }} {{ formatDateForMaistra(expiresOn) }}</div>
    </div>
    <p v-show="$router.currentRoute.value.name !== 'PointsActivity'">
      <router-link to="/activity">{{ $t('dashboard.viewPoints') }}</router-link>
    </p>
  </div>

  <div class="levels-progress__status">
    <div class="levels-progress__logos">
      <img v-for="level in LOYALTY_LEVELS" :src="level.imagesimple" :alt="level.title" loading="lazy">
    </div>
    <div class="levels-progress__bar-bg">
      <div class="levels-progress__bar-line" :style="{ width: level * 25 + '%'}"></div>
    </div>
    <p v-if="proceed">{{ proceed }}</p>
    <a :href="PREFIX + '/loyalty/benefits'">{{ $t('dashboard.moreAboutStatus') }}</a>
  </div>
</div>`,
  props: {
    availablePoints: Number,
    level: Number,
    proceed: String,
    expiresOn: Date,
  },
  setup (props) {
    return {
      LOYALTY_LEVELS,
      PREFIX,
      formatNumber,
      formatDateForMaistra,
    }
  },
}
